(function () {
    'use strict';

    angular
        .module('app.completions')
        .directive('completionsCell', completionsCell);

    completionsCell.$inject = [ 'opsIncludeVersion']
    /* @ngInject */
    function completionsCell(opsIncludeVersion) {
        
        var directive = {
            restrict: 'A',
            link: link,
            scope: {
                'item': '=',
                'completions': '=',
                'completionTypes': '='
              
            },
            templateUrl: 'app/completions/_completionCell.html?v=' + opsIncludeVersion
        };

        return directive;


        function link(scope, element, attrs) {
            
        }

        

    }

})();
